export var SelectPlacement;
(function (SelectPlacement) {
    SelectPlacement["TopLeft"] = "topLeft";
    SelectPlacement["TopRight"] = "topRight";
    SelectPlacement["BottomLeft"] = "bottomLeft";
    SelectPlacement["BottomRight"] = "bottomRight";
})(SelectPlacement || (SelectPlacement = {}));
//# sourceMappingURL=types.js.map